import { Box, Accordion, AccordionSummary, Skeleton, AccordionDetails } from '@mui/material';

const SyncItemsSkeleton = ({ count = 25 }) => {
  return (
    <Box>
      {Array.from({ length: count }).map((_, index) => (
        <Accordion
          key={index}
          sx={{
            mb: 1,
            boxShadow: 'none',
            '&:before': { display: 'none' },
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: '8px !important',
            overflow: 'hidden',
            '&:not(:last-child)': {
              borderBottom: '1px solid',
              borderColor: 'divider'
            },
            '& .MuiAccordionSummary-root': {
              borderRadius: '8px',
              transition: 'background-color 0.2s ease',
              '&:hover': {
                backgroundColor: 'action.hover'
              },
              py: 1
            },
            '& .MuiAccordionDetails-root': {
              borderTop: '1px solid',
              borderColor: 'divider',
              backgroundColor: 'background.default',
              p: 2
            }
          }}
        >
          <AccordionSummary
            sx={{
              py: 1,
              '& .MuiAccordionSummary-content': {
                margin: '12px 0'
              }
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
              <Skeleton variant='text' width='180px' height={26} />
              <Skeleton variant='rectangular' width={80} height={24} sx={{ borderRadius: 1 }} />
              <Skeleton variant='rectangular' width={60} height={24} sx={{ borderRadius: 1 }} />
            </Box>
          </AccordionSummary>
          <AccordionDetails sx={{ maxHeight: '300px', overflow: 'auto' }}>
            <Skeleton variant='rectangular' height={100} sx={{ borderRadius: 1 }} />
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default SyncItemsSkeleton;
